import { SignedIn, SignedOut } from "@clerk/remix";

import { StreakChip } from "./StreaksChip";
import { XPChip } from "./XPChip";
import { useContext } from "react";
import { AppContext } from "~/context/AppContext";
import { HeartsChip } from "./HeartsChip";
import { Link } from "@remix-run/react";

export const HomeScreenTopBar = () => {
  const { gameData } = useContext(AppContext);
  return (
    <div className="flex h-16 flex-row-reverse justify-between items-center w-full px-5 py-5 border-b-3 border-neutral-700">
      <SignedIn>
        <StreakChip streak={gameData?.userStats.streak ?? 0} />
        <XPChip
          xp={gameData?.userStats.overall_xp ?? 0}
          className="text-lg font-chewy text-white"
        />
        <HeartsChip hearts={gameData?.userStats.hearts ?? 0} />
      </SignedIn>
      <SignedOut>
        <Link
          to={"/sign-in"}
          className="flex flex-row justify-center items-center gap-2 font-bangers text-neutral-400"
        >
          log in
        </Link>
      </SignedOut>
    </div>
  );
};
